export const OPTION_HASH_VERSIONS = {
    V1: 'v1',
    V2: 'v2'
};
